import axiosInstance, { axiosInstanceForUploadFile } from "../../axios";
import AXIOS_ROUTES from "../../axios/routes";

export const getPresignedUrlApi = async ({
  filePath,
  fileName,
  fileType,
}: any) => {
  return await axiosInstance.get(
    `${AXIOS_ROUTES.files.getPresignedUrl}?filePath=${filePath}&fileName=${fileName}&fileType=${fileType}`
  );
};

export const uploadFileApi = async ({ presignedUrl, binaryFile }: any) => {
  return await axiosInstanceForUploadFile.put(presignedUrl, binaryFile);
};
